import React from 'react';
import {Grid, Card, CardContent, Divider, Tooltip,
        Button, Modal, InputBase, FormControl, withStyles, Link,
        ClickAwayListener, Dialog, Typography, TablePagination } from '@material-ui/core';
import {Pagination, Skeleton} from '@material-ui/lab'
import {ViewCarouselRounded, PeopleAlt, TableChartOutlined, LocalOfferOutlined, Apps,VisibilityOutlined, VisibilityOffOutlined,
        ExpandMore, ExpandLess, Lock, BubbleChart, Mic,
        PetsOutlined, SportsEsportsOutlined} from '@material-ui/icons'
import {withApollo} from 'react-apollo'
import { withRouter } from 'react-router-dom'
import axios from 'axios'
import gql from 'graphql-tag';
import request from 'superagent';

import config from '../../../config/backend'
import GameTopPanel from './gameTopPanel'
import FooterPanel from './gameFooterPanel.tsx';
import Landing from './landing';
import {HOME_PAGE_JAMBUILDER_QUERY, HOME_PAGE_GAME_QUERY, GET_USER_ACTIVITY, GET_JAMS_TEMPLATES,GET_JAMBUILDER, USER_ACCESS_QUERY} from '../../../api/graphql'
import CardLoader from '../user_interface/assets/cardLoader'
import {CREATE_GAME, CREATE_JAMBUILDER, USER_UPDATE_ACTIVITY,GAME_GD_UPDATE_BY_ID, DUPLICATE_GAME, USER_EVALUATE_TIER} from '../../../api/graphql-mutation'
import { getUserId, getUsername, replaceWhiteSpace, processDeckData} from '../../../utility/function';
import {styles} from './assets/frontPageUI'
import {ReactComponent as FPCards} from '../../../element/Icons/fpcards.svg'

import waving from '../../../element/2024aug/waving_hand.png'
import hat from '../../../element/2024aug/tall_hat.png'
import input_bp from '../../../element/2024aug/input_box_plump.png'

/** Components */
import { HelpFab } from '../../fabs/helpFab/helpFab';
import { HelpPopover } from '../../popovers/helpPopover/helpPopover';

/**temporary mock data */
import {gd,gd2} from '../../../utility/temp'

import '../../../app/app.css'
import { isEmpty } from 'lodash';
import { transform } from 'csv';

class FrontPage extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            jamListLength: 12,
            jamBuilderListLength: 3,
            templateListLength: 12,

            open: false,
            type: '',
            password: '',
            name: '',
            jamBuilder: [],
            deck: '1',
            loaded: true,

            //Activity list
            recentActivity: [],
            activityList: [],
            userJams: [],

            //Personal Jambuilders
            jambuilders: [],
            //Public jambuilders
            publicJambuilders: [],

            gamejams: [],
            spectateGame: [],
            uid: null,
            guest: false,

            anchorEl: null,
            stickyBits: null,

            //Dialog configs
            dialogOpen: false,
            selectedJB: {
                type: "story",
                jbData: null,
            },
            dialogDeck: null,

            templateDialog: false,

            templateImage: null,

            openPreview: this.props?.location?.state?.openPreview,

            loading: false,

            // Paginated list state
            jamPage: 1,

            loadDone: false,

            // Branch Pop Up
            branchPopUp: false,
            selectedBranch: null,
            branchPop: false,
            branchSuggest: false,

            testLoading: true,

            access: 0,
        }

        this.jbIndex = null
    }

    componentDidMount() {
        document.body.style.background = "#F2F2F2"

        this.props.client.query({
            query: gql`${HOME_PAGE_GAME_QUERY}`
        })
        .then((res) =>{
            const {gameMany} = res.data
            // console.log(gameMany)

            let readyGame = gameMany.filter((n)=>{return n.status === "ready"})
            let spectateGame = gameMany.filter((n)=>{return n.status === "started" && n.data.general.spectateMode})

            const gamejams = readyGame.filter((game)=>{return game.automation !== "2" && game.automation !== "3"})
            this.setState({
                loaded: true,
                gamejams: gamejams.reverse(),
                spectateGame: spectateGame.reverse(),

            })
        })
        .catch(() =>{
            return <div>Error :( : frontpage </div>
        })

        // if(getUserId()){
        //     console.log(getUserId())
        //     this.props.client.query({
        //         query: USER_ACCESS_QUERY(getUserId()),
        //     })
        //     .then((res)=>{
        //         console.log(res.data)
        //     })
        // }

        if(this.props?.location?.state?.type){
            const {type, selectedJB} = this.props.location.state
            this.setState({
                type: type,
                selectedJB: {
                    type: selectedJB.type,
                    jbData: selectedJB?.jbData
                }
            }, () =>{

                this.handleOpen(type)
                this.jbIndex = this.props.location.state.jbIndex
                this.jbID = this.state.selectedJB.jbData._id
            })
        }

    }

    render(){
        const {classes} = this.props
        const {gamejams, jambuilders, publicJambuilders, uid, activityList, spectateGame, userJams} = this.state
        const popoverId = this.state.anchorEl ? 'help-popover' : undefined;

        //console.log(this.state.branchSuggest,this.state.selectedBranch)
        //Shorthand alternative to "if" statement
        //So why is this a if statement? Putting the getUserId() in componentDidMount would return null even though
        //the user is logged in but will then return a valid uid after each subsequent function calls.
        //Therefore the stupid solution is to put it into render() and run the function until it returns
        //a valid uid and then query the data. This is what I call a pro gamer move
        Boolean(!uid && getUserId()) && this.jamPageQuery(getUserId())

        let x = getUserId()

        if(!getUserId() && !this.state.guest){
            this.templateQuery()
        }

        if(!isEmpty(spectateGame) && !this.state.loadDone){
            // console.log(spectateGame)
            this.setState({
                loadDone: true
            })
        }
        // console.log(this.state.testLoading)

        return(
            <>
                {!this.state.loaded && !this.state.testLoading ?
                    <div style ={{position: "absolute", left: "50%", top: "40%"}}><CardLoader/></div>
                    :
                    <>
                        {/* TOP PANEL */}
                        <GameTopPanel/>

                        {/* MAIN */}
                        { x ? 
                        
                            <Grid container spacing={4} className={classes.container}>
                                {/* LEFT COLUMN */}
                                <Grid item sm={9} xs={12}>
                                    {/* BANNER */}
                                    <img alt="banner" className={classes.banner} src={require('../../../element/2024feb/banner_front.png')}/>
                                    {/* FEATURED GAME JAM ROW */}

                                    
                                    {/* Access and Milestone */}

                                    <Card className={`${classes.card} ${classes.cardHeaderContainer}`} style={{marginBottom:"-15px"}}>
                                        <Grid container >
                                            <Grid item xs={12} className={classes.cardHeader}>
                                            Access
                                            </Grid>
                                        </Grid>
                                    </Card>
                                    <Card className={classes.card} style={{background:"transparent", border:"none", marginTop:"15px"}}>
                                        
                                            {this.TierProgress()}
                                        
                                    </Card>
                                    <Card className={`${classes.card} ${classes.cardHeaderContainer}`} style={{marginBottom:"-15px"}}>
                                        <Grid container >
                                            <Grid item xs={12} className={classes.cardHeader}>
                                            Milestone
                                            </Grid>
                                        </Grid>
                                    </Card>
                                    <Card className={classes.card} style={{background:"transparent", border:"none", marginTop:"15px"}}>
                                        
                                            {this.progressBar()}
                                        
                                    </Card>
                                    {/* HOST OR BUILD FROM JAMIT TEMPLATES */}
                                    <Card className={`${classes.card} ${classes.cardHeaderContainer}`} style={{marginBottom:"-15px"}}>
                                        <Grid container >
                                            <Grid item xs={12} className={classes.cardHeader}>
                                                Level 1: Host a jam from scratch
                                            </Grid>
                                        </Grid>
                                    </Card>

                                    {/* QUICK START WITH JAM TEMPLATES */}
                                    <Card className={classes.card} style={{background:"transparent", border:"none", marginTop:"15px"}}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={5}>
                                                <Grid
                                                    container
                                                    justify="center"
                                                    alignItems="center"
                                                    spacing={0}
                                                    className={classes.displayBox}
                                                    style={{filter: parseInt(this.state.access)<1 ? "grayscale(100%)": "none"}}
                                                    onClick={()=>{
                                                        if(parseInt(this.state.access)<1){
                                                            return
                                                        }
                                                        this.setState({
                                                            dialogOpen: true,
                                                            selectedJB:{
                                                                type: "story"
                                                            }
                                                        });
                                                    }}
                                                >
                                                    <Grid item xs={4} style={{background:"#74bfc9",borderRadius:"10px 0 0 10px",height:"120px"}}>
                                                        <img alt="icon" className={classes.displayImg} style={{marginLeft:"1.5em",height:"85px",position:"relative",top:"20px"}} src={require('../../../element/2024aug/user_switch.png')}/>
                                                    </Grid>
                                                    
                                                    <Grid item xs={8} className={classes.displayBg} style={{borderRadius:"0px 10px 10px 0px",background:"#faf7ea",border:"1px solid #faf7ea"}}>
                                                        <div className={classes.displayTitleWrapper} style={{marginLeft:"20px", marginTop:"10%"}}>
                                                            <p className={classes.displayTitle}>TURN-TAKING</p>
                                                            <p className={classes.displaySubTitle}>Each player gets a turn in<br/>sequential order</p>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={5}>
                                                <Grid
                                                    container
                                                    justify="center"
                                                    alignItems="center"
                                                    spacing={0}
                                                    className={classes.displayBox}
                                                    style={{filter: parseInt(this.state.access)<1 ? "grayscale(100%)": "none"}}
                                                    onClick={()=>{

                                                        if(parseInt(this.state.access)<1){
                                                            return
                                                        }

                                                        this.setState({
                                                            dialogOpen: true,
                                                            selectedJB:{
                                                                type: "freeStyle"
                                                            }
                                                        });
                                                    }}
                                                >
                                                    <Grid item xs={4} style={{background:"#74bfc9",borderRadius:"10px 0 0 10px",height:"120px"}}>
                                                        <img alt="icon" className={classes.displayImg} style={{marginLeft:"2em",position:"relative", height:"85px", top:"20px"}} src={require('../../../element/2024aug/zoom_gesture.png')}/>
                                                    </Grid>
                                                    <Grid item xs={8} className={classes.displayBg} style={{borderRadius:"0px 10px 10px 0px",background:"#faf7ea",border:"1px solid #faf7ea"}}>
                                                        <div className={classes.displayTitleWrapper} style={{marginLeft:"20px", marginTop:"10%"}}>
                                                            <p className={classes.displayTitle}>FREE PLAY</p>
                                                            <p className={classes.displaySubTitle}>Player free to engage<br/>without set turns</p>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Card>

                                    {/* CREATE YOUR OWN SECTION */} 
                                    <Card className={`${classes.card} ${classes.cardHeaderContainer}`} style={{marginBottom:"-15px"}}>
                                        <Grid container >
                                            <Grid item xs={12} className={classes.cardHeader}>
                                            Level 2: Host a jam from template
                                            </Grid>
                                        </Grid>
                                    </Card>
                                    <Card className={classes.card} style={{background:"transparent", border:"none", marginTop:"15px"}}>
                                        <Grid container spacing={2}>
                                                <Grid item xs={5}>
                                                    <Grid
                                                        container
                                                        justify="center"
                                                        alignItems="center"
                                                        spacing={0}
                                                        className={classes.displayBox}
                                                        //disable={parseInt("1")}
                                                        style={{filter: parseInt(this.state.access)<2 ? "grayscale(100%)": "none"}}
                                                        onClick={()=>{
                                                            // this.setState({
                                                            //     dialogOpen: true,
                                                            //     selectedJB:{
                                                            //         type: "brainstorm"
                                                            //     }
                                                            // });
                                                            // console.log(this.state.access)
                                                            if(parseInt(this.state.access)<2){
                                                                return
                                                            }

                                                            if(this.state.brainstormTemplate){
                                                                this.setState({
                                                                    dialogOpen: true,
                                                                    selectedJB: {
                                                                        jbData: this.state.brainstormTemplate,
                                                                        type: "custom-other",
                                                                        brainstorm: true,
                                                                    }
                                                                });
                                                            }else{
                                                                console.log("Unable to find brainstorm template ID")
                                                            }
                                                        
                                                        }}
                                                    >
                                                        <img alt="icon" className={classes.displayImg} style={{marginLeft:"2em",height:"80px",top:"20px"}} src={require('../../../element/2024aug/intellectual.png')}/>
                                                        <div className={classes.displayBg}>
                                                            <div className={classes.displayTitleWrapper} style={{marginTop:"5%"}}>
                                                                <p className={classes.displayTitle}>BRAINSTORM JAM</p>
                                                                <p className={classes.displaySubTitle}>Quick and process<br/>oriented</p>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Grid
                                                        container
                                                        justify="center"
                                                        alignItems="center"
                                                        spacing={0}
                                                        className={classes.displayBox}
                                                        style={{filter: parseInt(this.state.access)<2 ? "grayscale(100%)": "none"}}
                                                        onClick={()=>{
                                                            if(parseInt(this.state.access)<2){
                                                                return
                                                            }
                                                            if(this.state.firsttimeTemplate){
                                                                this.setState({
                                                                    dialogOpen: true,
                                                                    selectedJB: {
                                                                        jbData: this.state.firsttimeTemplate,
                                                                        type: "custom-other",
                                                                        firsttime: true,
                                                                    }
                                                                });
                                                            }else{
                                                                console.log("Unable to find first-time template ID")
                                                            }
                                                        
                                                        }}
                                                    >
                                                        <img alt="icon" className={classes.displayImg} style={{marginLeft:"3.5em",height:"80px",top:"20px"}} src={require('../../../element/2024aug/painting_board.png')}/>
                                                        <div className={classes.displayBg}>
                                                            <div className={classes.displayTitleWrapper} style={{marginTop:"5%"}}>
                                                                <p className={classes.displayTitle}>COVER JAM</p>
                                                                <p className={classes.displaySubTitle}>Don't judge a book by<br/>its cover</p>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                        </Grid>
                                    </Card>
                                    <div style={{marginBottom:"10em"}}>

                                    </div>
                                </Grid>

                                {/* RIGHT COLUMN */}
                                <Grid item sm={3} xs={12}>
                                    {/* USER'S RECENT ACTIVITY */}
                                    {/* //TODO: Change the user model to accomodate to recent activities */}
                                    {uid && activityList &&
                                        <Grid item xs={12}>
                                            <Card className={classes.card} style={{background:"white", marginTop:"0"}}>
                                                <CardContent style={{padding:"20px"}}>
                                                    <p style={{fontSize:"20px", fontWeight:"bold"}}>
                                                        Recent jams
                                                    </p>
                                                    <Grid container>
                                                    {
                                                        activityList.length > 0 ?
                                                            this.displayActivity(classes, activityList)
                                                        :
                                                        <>
                                                            <img alt="empty" style={{width:"150px", height:"150px",  marginLeft:"18%"}} src={require('../../../element/cat.png')}/>
                                                            <p className={classes.ownJamEmpty}>
                                                                You don’t have anything on your <br/>dashboard yet. <br/><br/>
                                                                Why don't you start building<br/> or hosting a jam?
                                                            </p>
                                                        </>
                                                    }
                                                    </Grid>
                                                </CardContent>
                                                {/* {jambuilders.length > this.state.jamBuilderListLength?
                                                    this.state.jamBuilderListLength !== jambuilders.length ?
                                                    <>
                                                        <Divider/>
                                                        <Button  className={classes.moreBtn} onClick={()=>{this.setState({jamBuilderListLength:jambuilders.length})}} startIcon={<ExpandMore/>}>
                                                            Show all
                                                        </Button>
                                                    </>
                                                    :
                                                    <>
                                                        <Divider/>
                                                        <Button  className={classes.moreBtn} onClick={()=>{this.setState({jamBuilderListLength: 2})}} startIcon={<ExpandLess/>}>
                                                            Show less
                                                        </Button>
                                                    </>
                                                :
                                                    null
                                                }   */}
                                            </Card>
                                        </Grid>
                                    }

                                    {/* USER'S OWN TEMPLATES */}
                                    {uid && userJams &&
                                        <Grid item xs={12}>
                                            <Card className={classes.card} style={{background:"white", marginTop:"0"}}>
                                                <CardContent style={{padding:"20px 20px 5px 20px"}}>
                                                    <p style={{fontSize:"20px", fontWeight:"bold"}}>
                                                        All jams
                                                    </p>
                                                    {this.displayPaginated(classes,this.state.recentActivity)}
                                                    
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    }

                                    {/* BANNER */}
                                    {!uid &&
                                        <Grid item xs={12}>
                                            <img alt="banner" className={classes.banner} src={require('../../../element/banner6.png')}/>
                                        </Grid>
                                    }
                                </Grid>
                            </Grid> 
                        
                        : 
                            <Grid container spacing={4}  className={classes.container} style={{height:"80vh",width:"100%", maxWidth:"100%"}}>
                                <Grid item md={7} xs={12}
                                    style={{ 
                                    backgroundColor: "#A8B0B3", // gray background
                                    display: "flex", 
                                    alignItems: "center", 
                                    justifyContent: "center"
                                    }}
                                >
                                    <img 
                                    src={require("../../../element/2024aug/landing.png")} 
                                    alt="illustration" 
                                    style={{ maxWidth: "80%", height: "auto" }} 
                                    />
                                </Grid>
                                <Grid item md={5} xs={12}
                                    style={{ 
                                    display: "flex", 
                                    alignItems: "center", 
                                    justifyContent: "center", 
                                    backgroundColor: "#A8B0B3" 
                                    }}
                                >
                                     <Landing/>     
                                </Grid>        
                                             
                            </Grid>
                            
                        }

                        {/* FOOTER */}

                        <FooterPanel/>

                        {/* POP UP */}
                        <Modal disableAutoFocus={true} className={classes.modal} open={this.state.open} onClose={this.handleClose}>
                            {this.popUp(classes)}
                        </Modal>
                        <Modal disableAutoFocus={true} className={classes.modal} open={this.state.branchPop} onClose={()=>{this.setState({branchPop:false})}}>
                            {this.branchModal(classes)}
                        </Modal>

                        {/* HELP POPOVER */}
                        <ClickAwayListener onClickAway={this.closePopper}>
                            <div>
                                <HelpPopover
                                    id={popoverId}
                                    anchorEl={this.state.anchorEl}
                                />
                                <HelpFab openHelpPopper={this.openPopper} />
                            </div>
                        </ClickAwayListener>

                        {/* TEMPLATE PREVIEW DIALOG */}
                        <Dialog
                            onClose={() =>
                                this.setState({
                                    dialogOpen: false,
                                    dialogDeck: null,
                                })}
                            open={this.state.dialogOpen}
                        >
                            {this.state.dialogOpen && this.displayInfo()}
                        </Dialog>
                        <Dialog
                            onClose={()=>{
                                this.setState({
                                    branchPopUp: false,
                                    selectedBranch: null,
                                })
                            }}
                            open={this.state.branchPopUp}
                        >
                            {this.state.branchPopUp && this.displayBranchInfo()}
                        </Dialog>
                    </>
                }
            </>
        )
    }

    handleDropFile = (files) => {
        // console.log('Drop file', files);
        const file = files.shift();
        this.setState({
            templateImage: {...files}
        })
        //console.log(this.state.draft.toObject());
        // this.state.draft.syncImage(file);

        const data = new FormData();
        data.append('image', file);

        // const req = request.post(`${config.backend.uri}/upload`);
        const req = request.post(`${config.backend.uri}/api/upload`);

        req.on('progress', (event) => {
          const percent = Math.floor(event.percent);
          if (percent >= 100) {
            this.setState({ imageCompleted: 100 });
          } else {
            this.setState({ imageCompleted: percent });
          }
        });
        req.send(data);
        req.end((err, res) => {
          // this.state.draft.set('image', { ...file, ...res.body.data.upload });
          this.setState({
              templateImage: {...file, ...res.body.data.upload}
          })

          // console.log(this.state.templateImage)
        });
    }

    //Help popper
    openPopper = (e) =>{
        this.setState({
            anchorEl: e.currentTarget
        });
    }

    //Help popper
    closePopper = () =>{
        this.setState({
            anchorEl: null
        });
    }

    // query for non-logged in
    templateQuery = () => {

        const observable = this.props.client.watchQuery({
            query: GET_JAMBUILDER(),
            fetchPolicy: 'cache-and-network'
        })

        this.subscription = observable.subscribe({
            next: ({data , loading}) => {
                // console.log(data)

                if(data){
                    let jbs = data.jamBuilderMany
                    let publicJambuilders = []

                    jbs.forEach((jamBuilder) => {
                        if(jamBuilder?.general?.privacy === "Public" && jamBuilder?.status === "interpreted"){
                            publicJambuilders.push(jamBuilder)
                        }
                    })


                    let brainstormTemplate = publicJambuilders.find((pjb)=>{return pjb._id === "669e20bbcad6291beae230eb"})
                    let firsttimeTemplate = publicJambuilders.find((pjb)=>{return pjb._id === "662f21cc0d8d0f348cf5c3cd"})

                    this.setState({
                        publicJambuilders: publicJambuilders,
                        guest: true,
                        brainstormTemplate,
                        firsttimeTemplate,
                        testLoading: loading,
                    })
                }

            },
            error: (error) => {
                console.log(error)
            }

        })


        // this.props.client.query({
        //     query: GET_JAMBUILDER(),
        // }).then((res) =>{
        //     //console.log(res)
        //     let jbs = res.data.jamBuilderMany
        //     let publicJambuilders = []

            

        //     jbs.forEach((jamBuilder) => {
        //         if(jamBuilder?.general?.privacy === "Public" && jamBuilder?.status === "interpreted"){
        //             publicJambuilders.push(jamBuilder)
        //         }
        //     })


        //     let brainstormTemplate = publicJambuilders.find((pjb)=>{return pjb._id === "669e20bbcad6291beae230eb"})
        //     let firsttimeTemplate = publicJambuilders.find((pjb)=>{return pjb._id === "662f21cc0d8d0f348cf5c3cd"})

        //     this.setState({
        //         publicJambuilders: publicJambuilders,
        //         guest: true,
        //         brainstormTemplate,
        //         firsttimeTemplate
        //     })
            
           
        // })
    }


    // query for logged in 
    jamPageQuery = (uid) =>{
        let access = ""
        this.props.client.query({
            query: gql`${HOME_PAGE_JAMBUILDER_QUERY}`,
            variables: {uid: uid}
        })
        .then((res) =>{
            // console.log(res.data)
            const {jamBuilderMany,userById} = res.data
            let personalJamBuilders = []
            let publicJambuilders = []
            access = userById.access

            if(!userById.access){
                // No tier cached yet — ask the server to compute it, then refresh.
                this.props.client.mutate({
                    mutation: USER_EVALUATE_TIER,
                    variables:{
                        _id: uid,
                    }
                }).then((res) =>{
                    window.location.reload()
                })
            }

            this.props.client.query({
                query: GET_USER_ACTIVITY(uid)
            }).then((res) =>{
                //recentActivity has recentTemplates and recentJams,
                //these two data will store the oldest accessed activities starting from 0
                
                const recentActivity = res.data.userById.recentActivity
                const recentTemplates = recentActivity.recentTemplates.map((template) =>{
                    return template._id
                })
                const recentJams = recentActivity.recentJams.map((game) =>{
                    return game._id
                })

                const userJams = res.data.gameMany
                let filteredUserJams = userJams.filter((j)=>{
                    return j.name !== "Untitled Jam"
                })

                filteredUserJams.reverse()

                //console.log(userJams)
                //console.log(filteredUserJams)

                //Perhaps there's a better way to query activity, perhaps not
                //I spent way too much time and care so this nested query is the only way for now
                this.props.client.query({
                    query: gql`${GET_JAMS_TEMPLATES}`,
                    variables:{tempList : recentTemplates, jamList: recentJams}
                }).then((res) =>{

                    //Combines both objects into one based on ID
                    const jamBuilders = res.data.jamBuilderFilter.map(obj => Object.assign(obj, recentActivity.recentTemplates.find(templates => obj._id === templates._id)))
                    const games = res.data.gameFilter.map(obj => 
                        Object.assign(obj, recentActivity.recentJams.find(templates => 
                            obj._id === templates._id)
                        )
                    )

                    let activityList = jamBuilders.concat(games)

                    let sortedActivity = activityList.sort((a, b) => (new Date(a.date).getTime()) < (new Date(b.date).getTime()) ? 1 : (( (new Date(b.date).getTime()) <  (new Date(a.date).getTime())) ? -1 : 0))

                    jamBuilderMany.forEach((jamBuilder) => {
                        //console.log(jamBuilder)
                        if(jamBuilder.createdBy._id === uid){
                            personalJamBuilders.push(jamBuilder)
                        }

                        if(jamBuilder?.general?.privacy === "Public" && jamBuilder?.status === "interpreted"){
                            publicJambuilders.push(jamBuilder)
                        }
                    })

                    let brainstormTemplate = publicJambuilders.find((pjb)=>{return pjb._id === "669e20bbcad6291beae230eb"})
                    let firsttimeTemplate = publicJambuilders.find((pjb)=>{return pjb._id === "662f21cc0d8d0f348cf5c3cd"})

                    this.setState({
                        jambuilders: personalJamBuilders.reverse(),
                        publicJambuilders: publicJambuilders.reverse(),
                        uid: uid,
                        activityList: sortedActivity,
                        userJams: filteredUserJams,
                        brainstormTemplate, // temporary state register for brainstormTemplate
                        firsttimeTemplate, // temporary state register for firsttimeTemplate
                        recentActivity: games,
                        access, 
                    }, ()=>{
                        if(this.props?.location?.state?.openPreview){
                            this.reloadPage()

                            const {jbID} = this.props.location.state
                            let jbData = null

                            for(let i=0; i<this.state.jambuilders.length; i++){
                                if (this.state.jambuilders[i]._id === jbID){
                                    jbData = this.state.jambuilders[i]
                                    this.jbIndex = i
                                    break
                                }
                            }
                            this.jbID = jbID

                            this.setState({
                                dialogOpen: true,
                                selectedJB: {
                                    jbData: jbData,
                                    type: "custom-personal"
                                }
                            })
                        }
                    })
                })
            })
        })
        .catch(() =>{
            return <div>Error :( : frontpage </div>
        })
    }

    reloadPage = () =>{
        // The last "domLoading" Time //
        var currentDocumentTimestamp =
        new Date(performance.timing.domLoading).getTime();
        // Current Time //
        var now = Date.now();
        // Ten Seconds //
        var tenSec = 10 * 1000;
        // Plus Ten Seconds //
        var plusTenSec = currentDocumentTimestamp + tenSec;
        if (now > plusTenSec) {
            window.location.reload();
        } else {

        }
    }
    getParameter = () =>{
        return window.location.href.slice(-1)
    }

    addJamListLength = () => {
        this.setState({
            jamListLength: this.state.jamListLength + 12
        })
    }

    addTemplateListLength = () => {
        this.setState({
            templateListLength: this.state.templateListLength + 12
        })
    }

    handleOpen(getType){
        this.setState({
            open: true,
            type: getType
        })
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    passwordChecker = () => {
        if(this.state.password === ""){
            return null
        }else{
            return this.state.password
        }
    }

    handleChange = (event) => {
        let item = event.target.name
        this.setState({
            [item]: event.target.value
        })
    }

    handleCreateJam = () => {
        if (this.state.loading) {
            return;
        }

        if (this.state.type === '' || this.state.name === ''){
            alert('Please Fill All Information!');

            return;
        }

        if (this.state.type === '3'){
            this.createBranch()
        }else{
            this.createGame();
        }


        this.setState({ loading: true });
    };

    TierProgress() {
        const steps = [
        {
        level: "Level 1",
        text: "Created an account",
        icon: waving,
        unlocked: parseInt(this.state.access) > 0
        },
        {
        level: "Level 2",
        text: "Hosted a jam",
        icon: hat,
        unlocked: parseInt(this.state.access) > 1
        },
        {
        level: "Level 3",
        text: "Earned top contributor",
        icon: input_bp,
        unlocked: parseInt(this.state.access) > 2
        },
    ];

    return (
        <div
        style={{
            display: "flex",
            gap: "10px",
            justifyContent: "center",
            marginTop: "20px",
        }}
        >
        {steps.map((step, index) => (
            <div
            key={index}
            style={{
                flex: "1",
                minWidth: "220px",
                padding: "12px",
                borderRadius: "6px",
                backgroundColor: step.unlocked ? "#d4f8d4" : "#f0f0f0",
                color: step.unlocked ? "#000" : "#666",
                display: "flex",
                alignItems: "center",
                border: "1px solid #ccc",
            }}
            >
            {/* Icon */}
            <img
                src={step.icon}
                alt={step.level}
                style={{ width: "30px", height: "30px", marginRight: "10px" }}
            />

            {/* Texts inline */}
            <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ fontWeight: "bold", fontSize: "14px" }}>
                {step.level}
                </div>
                <div style={{ fontSize: "13px" }}>{step.text}</div>
            </div>
            </div>
        ))}
        </div>
    );

    }


    progressBar = () => {
        const steps = [
            { label: "Hosted a jam", icon: waving },
            { label: "Earned top contributor", icon: hat },
            { label: "Next milestone", icon: input_bp},
        ];

        //console.log(this.state.access)
        const currentStep = this.state.access; // 0-based index of progress

        return (
            <div
            style={{
                display: "flex",
                alignItems: "center",
                width: "800px",
                margin: "20px 0",
            }}
            >
            {steps.map((step, index) => (
                <React.Fragment key={index}>
                {/* Step Icon */}
                <div
                    style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "8px",
                    border: index < currentStep ? "2px solid #4caf50" : "2px solid #4f4f4f",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: index < currentStep ? "#c9f3cd" : "#e0e0e0",
                    zIndex: 2,
                    }}
                >
                    <img
                    src={step.icon}
                    alt={step.label}
                    style={{ width: "30px", height: "30px" }}
                    />
                </div>

                {/* Bar (only render if not last step) */}
                {index < steps.length - 1 && (
                    <div
                    style={{
                        flex: 1,
                        height: "30px",
                        //margin: "0 8px",
                        // borderRadius: "6px",
                        backgroundColor: index < currentStep-1 ? "#d4af37" : "#e0e0e0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#333",
                        fontSize: "14px",
                        fontWeight: "500",
                    }}
                    >
                    {step.label}
                    </div>
                )}
                </React.Fragment>
            ))}
            </div>
        );
    }

    //Game/Jambuilder modal
    popUp = (classes) => {
        //Note: type === 1 is Jam, 0 is Template
        const {type} = this.state

        return (
            <Card className={classes.popUp}>
                <div className={classes.popUpHeader}>
                    {type !== "0" ? "Host a new Jam" : "Create a new Template"}
                </div>
                <Divider/>
                <div className={classes.popUpContent}>
                    <FormControl style={{width: "100%", fontSize:"0.875rem", color:"#4F4F4F"}}>
                        <b>{type !=="0" ? "Jam Name *" : "Template Name *"}</b>
                        <p style={{color:"#828282", fontSize:"0.7rem", marginBottom:"5px"}}>Give your jam a unique name!</p>
                        <InputBase
                            className={classes.field}
                            placeholder="Example: Wayne's World"
                            name="name"
                            value={this.state.name}
                            onChange={this.handleChange}
                            inputProps={{style: {fontSize: "0.875rem", fontFamily:"arial" }, maxLength:17}}
                        />
                        {type !== "0" ?
                        <>
                            <div style={{fontSize:"0.875rem", color:"#4F4F4F",}}>
                                <b>Jam Password</b>
                                <i style={{marginLeft:"0.2em", color:"#B8B8B8"}}>(Optional)</i>
                                <p style={{color:"#828282", fontSize:"0.7rem", marginBottom:"5px"}}>Only those with your jam’s password may view your waiting room. If none is set, anyone can view your waiting room!</p>
                            </div>
                            <InputBase
                                className={classes.field}
                                type="password"
                                placeholder="password"
                                name="password"
                                value={this.state.password}
                                onChange={this.handleChange}
                                inputProps={{style: {fontSize: "0.875rem", fontFamily:"arial" }}}
                            />
                        </> :
                        null
                        }
                        {type !== "0" ?
                        <>
                            <Button
                                onClick={this.handleCreateJam}
                                disabled={(this.state.name === '' ? true : false) || this.state.loading}
                                className={this.state.name === '' ? classes.popUpBtnDisabled : classes.popUpBtn}
                            >
                               {this.state.selectedJB.firsttime ? "Start Game": "Go to waiting room"} 
                            </Button>
                        </> :
                        <>
                            <Button
                                onClick={()=>{
                                    if(this.state.name === ""){
                                        alert("Please Fill All Information!")
                                    }else{
                                        this.createTemplate()
                                    }
                                }}
                                disabled={this.state.name === "" ? true:false}
                                className={this.state.name === "" ? classes.popUpBtnDisabled : classes.popUpBtn}
                            >
                                Go to Template Builder
                            </Button>
                        </>
                        }
                    </FormControl >
                </div>
            </Card>
        )
    }

    branchModal = (classes) => {
        //Note: type === 1 is Jam, 0 is Template
        const {selectedBranch} = this.state
        // console.log(selectedBranch)
        if(selectedBranch){
            return (
                <Card className={classes.popUp}>
                    <div style={{textAlign:"center",whiteSpace:"break-spaces"}} className={classes.popUpHeader}>
                        Branch a Jam{"\n"}<span>{selectedBranch && selectedBranch.name}</span>
                    </div>
                    <Divider/>
                    <div className={classes.popUpContent}>
                        <FormControl style={{width: "100%", fontSize:"0.875rem", color:"#4F4F4F"}}>
                            <b>Jam Name *</b>
                            <p style={{color:"#828282", fontSize:"0.7rem", marginBottom:"5px"}}>Give your jam a unique name!</p>
                            <InputBase
                                className={classes.field}
                                placeholder="Example: Wayne's World"
                                name="name"
                                value={this.state.name}
                                onChange={this.handleChange}
                                inputProps={{style: {fontSize: "0.875rem", fontFamily:"arial" }, maxLength:17}}
                            />
                            <div style={{fontSize:"0.875rem", color:"#4F4F4F",}}>
                                    <b>Jam Password</b>
                                    <i style={{marginLeft:"0.2em", color:"#B8B8B8"}}>(Optional)</i>
                                    <p style={{color:"#828282", fontSize:"0.7rem", marginBottom:"5px"}}>Only those with your jam’s password may view your waiting room. If none is set, anyone can view your waiting room!</p>
                            </div>
                            <InputBase
                                    className={classes.field}
                                    type="password"
                                    placeholder="password"
                                    name="password"
                                    value={this.state.password}
                                    onChange={this.handleChange}
                                    inputProps={{style: {fontSize: "0.875rem", fontFamily:"arial" }}}
                            />
                            <div style={{fontSize:"0.875rem", color:"#4F4F4F",}}>
                                    <b>Jam Template</b>
                                    <p style={{color:"#828282", fontSize:"0.7rem", marginBottom:"5px"}}>
                                        Use back the same template as the original jam or starts fresh as a freestyle jam!
                                    </p>
                                    {(selectedBranch.data.general.suggestedTemplate && selectedBranch.data.general.suggestedTemplate !== "") &&
                                        <div  style={{paddingTop:"1em",fontSize:"14px"}}>
                                            <button onClick={()=>{
                                                this.setState({
                                                    branchSuggest: !this.state.branchSuggest
                                                })
                                            }} 
                                            style={{width:"100%",marginRight:"1em", padding:"1em", borderRadius:"5px",background: this.state.branchSuggest ? "#00dfff":"#fff3b4"}}>
                                                <span style={{fontWeight:"bold",fontSize:"16px"}}>Suggested</span><br/>
                                                <span>{this.linkSegment(selectedBranch.data.general.suggestedTemplate)}</span>
                                            </button>
                                        </div>
                                    }
                                    <div style={{padding:"1em 0", fontSize:"14px"}}>
                                        <button style={{width:"155px",marginRight:"1em", padding:"1em", borderRadius:"5px",background:"white"}}>Reuse Template</button>
                                        <button style={{width:"155px", padding:"1em", borderRadius:"5px", background:"white"}}>Freestyle</button>
                                    </div>
                            </div>
                            <Button
                                    onClick={this.handleCreateJam}
                                    disabled={(this.state.name === '' ? true : false) || this.state.loading}
                                    className={this.state.name === '' ? classes.popUpBtnDisabled : classes.popUpBtn}
                                >
                                    Go to waiting room
                            </Button>           
                        </FormControl >
                    </div>
                </Card>
            )
        }

    }

    //Dialog popup to display info
    displayInfo = () =>{
        const {classes} = this.props
        const {selectedJB} = this.state
        //Default dialog data starts with "Basic Game"
        let image = require('../../../element/default-image.png')
        let name = "Basic Game"
        let description = "The most basic template ready to be used and modified to your needs. This template consists of 5 set of card decks from Character, Place, Events and 1 blank card for players to customize their own story"
        let endpoint = "storyDesign"

        // if redirect set jbID to redirect jbID
        if(this.props.location?.state?.redirect){
            this.jbID = this.props.location.state.jbID
        }

        if(selectedJB.type === "custom-personal" || selectedJB.type === "custom-other"){
            selectedJB?.jbData?.image ?
                image = `${config.backend.uri}/static/uploads/${selectedJB.jbData.image}` :
                image = require('../../../element/default-image.png')

            name = selectedJB.jbData.name
            description = selectedJB?.jbData?.general?.description
            endpoint = selectedJB.jbData.deckEndpoint
        }
        else if(selectedJB.type === "story"){
            name = "Story Game"
            description = "Everything you need to have to build story game. This template consists of 5 set of card decks from Character, Place, Events and 1 blank card for players to customize their own story"
            image = require('../../../element/OUAT1.jpg')
        }
        else if(selectedJB.type === "freeStyle"){
            name = "Free Style"
            description = "A jam in its simplest form. This template consists of many sets of card decks from Topics to Characters while allowing everyone to jam together at the same time."
        }else if(selectedJB.type === "brainstorm"){
            name = "Brainstorm"
            description = "New Brainstorm Jam"
        }

        if(!this.state.dialogDeck){

            var deckAPI;
            var p;
            if(endpoint === "storyDesign"){
                deckAPI = `/api/game/getDeck`
                p = {
                    endpoint,
                }
            }else if(endpoint === "brainstorm"){
                deckAPI = '/api/game/getDeck'
                p = {
                    endpoint: 'brainstorm'
                }
            }else{
                deckAPI = `/api/game/getCustomDeck`
                p = {
                    endpoint,
                    userDir: `${selectedJB.jbData.createdBy._id}-${replaceWhiteSpace(selectedJB.jbData.createdBy.name.first)}`,
                }
            }


            axios.get(`${config.backend.uri}${deckAPI}`,{params: p}).then((res)=>{
                let dialogDeck = res.data.deck.elements

                this.setState({
                    dialogDeck: dialogDeck
                })
            })
        }
        else{
            return(
                <div className={classes.preview}>
                    <Grid container>
                        <Grid item xs={8}>
                            {/* <img alt="media-preview" className={classes.previewImage} src={image}/>   */}

                            <div style={{backgroundImage: `url(${image})`, backgroundSize: 'cover'}} className={classes.previewImage}></div>

                            <p style={{fontSize:"14px",fontWeight:"bold", color:"#4F4F4F"}}>
                                {name}
                            </p>
                            <p style={{paddingRight:"20px", color:"#4F4F4F", fontSize:"14px"}}>
                                {description}
                            </p>
                        </Grid>
                        <Grid item xs ={4}>
                            <Button
                                className={classes.previewBtn}
                                onClick={()=>{
                                    if(!getUserId()){
                                        this.props.history.push({
                                            pathname: "/login",
                                            state:{
                                                selectedJB: selectedJB,
                                                type: "1",
                                                jbIndex: this.jbIndex
                                            }
                                        })
                                    }
                                    else{
                                        this.setState({
                                            dialogOpen: false
                                        },()=>{
                                            this.handleOpen("1")
                                        })
                                    }
                                }}
                                size={"small"}

                            >
                                Host This Template
                            </Button>

                            {/* Customize template button
                            <p style={{textAlign:"center"}}>
                                <Link
                                    style={{
                                        color:"orange",
                                        fontSize:"14px",
                                        fontWeight:"bold",
                                        textDecoration:"underline",
                                        cursor:"pointer",
                                    }}
                                    size={"small"}
                                    onClick={()=>{
                                        if(!getUserId()){
                                            this.props.history.push({
                                                pathname: "/login",
                                                state:{
                                                    selectedJB: selectedJB,
                                                    type: "0",
                                                    jbIndex: this.jbIndex
                                                }
                                            })
                                        }
                                        else{
                                            this.handleDisplayInfoClick(selectedJB)
                                        }
                                    }}
                                >
                                    Customize this Template
                                </Link>
                            </p>*/}
                            <p style={{fontWeight:"bold", marginTop:"20px", fontSize:"14px", color:"#4F4F4F"}}>
                                Deck List ({this.state.dialogDeck?.length})
                            </p>

                            {this.state.dialogDeck.slice(0,3).map((card, index) =>{
                                return(
                                    <div key={`${card}-${index}`} className={classes.previewCard}>
                                        <p style={{fontWeight:"bold", color:"#4F4F4F"}}>
                                           {card.content}
                                        </p>
                                        <Tooltip title="Category">
                                            <p style={{background:"#5C969A",}} className={classes.previewCardLabel}>
                                                <Apps className={classes.previewCardIcon}/>
                                                {card.category}
                                            </p>
                                        </Tooltip>
                                        {card.label.map((label, index) =>{
                                            return (
                                                <Tooltip key={`${label}-${index}`} title="Label">
                                                    <p style={{background:"#967B7B"}} className={classes.previewCardLabel}>
                                                        <LocalOfferOutlined className={classes.previewCardIcon}/>
                                                        {label}
                                                    </p>
                                                </Tooltip>
                                            )
                                        })}
                                    </div>
                                )
                            })}
                        </Grid>
                    </Grid>
                </div>
            )
        }
    }

    displayBranchInfo = () => {
        const {classes} = this.props
        const {selectedBranch} = this.state

        console.log(selectedBranch)

        return(
            <div style={{background:"beige",marginBottom:"0"}} className={classes.preview}>
                <Grid container>
                    <Grid item xs={9}>
                        <h2>{selectedBranch.name}</h2>
                        <div style={{width:"90%", height:"300px",padding:"16px",boxSizing:"border-box",background:"white", overflow:"hidden", position:"relative"}} className={classes.previewImage}>
                            <iframe src={`/game/${selectedBranch.id}?preview=true&id=${selectedBranch._id}`} 
                            style={{transform: "scale(0.5)", transformOrigin:"top left", width:"200%", height:"500px", border:"none",display:"block"}}></iframe>
                            {selectedBranch.data.objects.map(o=>
                                <p>{o.category}: {o.content}</p>
                            )}
                        </div>
                        <p>Template: Freestyle</p>
                        <p>A jam in its simplest form. This template consists of many sets of card decks from Topics to Characters while allowing everyone to jam together at the same time.</p>
                    </Grid>
                    <Grid item xs={3}>
                        <Button
                            className={classes.previewBtn}
                            onClick={()=>{
                                window.location.href=`/game/${selectedBranch._id}`
                            }}
                        >
                            OPEN JAM
                        </Button>
                        <Button
                            className={classes.previewBtn}
                            onClick={()=>{
                                this.setState({
                                    branchPopUp: false,
                                    branchPop: true,
                                    type: '3',
                                })
                            }}
                        >
                            BRANCH JAM
                        </Button>
                        <h2>Jam Member</h2>
                        {selectedBranch.participants.map((p,index)=>
                            <p style={{fontSize:"16px"}}>👤 <strong>{p.username}</strong>{index === 0 && <span style={{position:"relative",fontSize:"10px",color:"orange",top:"12px",right:"39px"}}>Host</span>}</p>
                        )}
                        
                    </Grid>
                </Grid>
            </div>
        )   

    }

    skeletonLoader = (classes,n) => 
        [...Array(n)].map((_,index)=>(
            <Grid
            container
            //onClick={()=>{window.location.href=`/game/${game._id}`}}
            justify="center"
            alignItems="center"
            spacing={0}
            className={classes.jamBox}
            style={{height:"100px"}}
        >
                {/* JAM IMAGE */}
                <Grid item xs={4} className={`${classes.jamBoxImg} skeleton`} style={{background:"#BB5E0B"}}>

                    <SportsEsportsOutlined style={{color:"white", marginTop:"10px",fontSize:"70px"}}/>
                </Grid>
                {/* JAM INFO */}
                <Grid item xs={8} className={classes.jamBoxFont} style={{padding:"10px", fontSize:"12px"}}>
                    <div className={`skeleton-text skeleton`}></div>
                    <div className={`skeleton-text skeleton`}></div>
                    <div className={`skeleton-text skeleton`}></div>
                </Grid>
            </Grid>
        ))
    

    displayPaginated = (classes,userJams) => {
        // console.log(userJams)
        let page = this.state.jamPage
        //let itemsPerPage = 5
        //const startIndex = (page - 1) * itemsPerPage;
        //const endIndex = startIndex + itemsPerPage;
        //const currentItems = userJams.slice(startIndex, endIndex);

        let itemsPerPageOptions = [5];
        let rowsPerPage = 5
        const startIndex = page * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;
        const currentItems = userJams.slice(startIndex,endIndex)

      
        return (
            <Grid container>
            {
                currentItems.length > 0 ?
                currentItems.map( (jam,index) => (
                        <Grid
                            key={`${index}`}
                            container
                            justify="center"
                            alignItems="center"
                            spacing={0}
                            className={classes.jamBox}
                            style={{height:"100px"}}
                            onClick={() =>{
                                this.props.client.mutate({
                                    mutation: USER_UPDATE_ACTIVITY,
                                    variables:{
                                        _id: this.state.uid,
                                        _aid: jam._id,
                                        type: "jam",
                                        date: new Date()
                                    }
                                }).then(() =>{
                                    this.props.history.push({
                                        pathname: `/game/${jam._id}`
                                    })
                                })
                            }}
                        >
                            {/* JAM IMAGE */}
                            <Grid item xs={4} className={classes.jamBoxImg} style={{background:"#faf7ea"}}>
                                <FPCards style={{color:"white", marginTop:"10px",fontSize:"50px"}}/>
                            </Grid>
                            {/* JAM INFO */}
                            <Grid item xs={8} className={classes.jamBoxFont} style={{fontSize:"12px", padding:"10px"}}>
                                <span style={{fontWeight:"bold", fontSize:"16px"}}>
                                    {jam?.name}
                                    {jam?.protected && <Lock style={{fontSize:"14px", marginTop:"-3px", marginLeft:"5px", color:"#C4C4C4"}}/>}
                                </span><br/>
                                Hosted by {jam?.createdBy?.name?.first} <br/>
                                <span style={{fontSize:"8px"}}>
                                    <PeopleAlt className={classes.jamBoxIcon}/>
                                </span>
                                {jam?.participants?.length }
                            </Grid>
                        </Grid>
                    ))
                :

                <>
                    <img alt="empty" style={{width:"150px", height:"150px", marginLeft:"18%"}} src={require('../../../element/cat.png')}/>
                    <p className={classes.ownJamEmpty}>
                        You don’t have anything on your <br/>dashboard yet. <br/><br/>
                        Why don't you start building<br/> or hosting a jam?
                    </p>
                </>
            }
            <Grid container style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2}}>
                {/**<Typography variant="body2">
                Showing {currentItems.length} of {userJams.length} jams
                </Typography>
                <Pagination
                count={Math.ceil(userJams.length / itemsPerPage)}
                page={page}
                onChange={this.handleChangePage}
                variant="outlined"
                shape="rounded"
                />**/}
                <div style={{ display: 'flex',justifyContent: 'space-between',alignItems: 'center',padding: '10px',borderTop: '1px solid #ccc'}}>
                    <Typography variant="body2">
                    Showing {startIndex + 1} to {Math.min(endIndex, userJams.length)} of {userJams.length} jams
                    </Typography>
                    <TablePagination
                    component="div"
                    count={userJams.length}
                    page={page}
                    onChangePage={this.handleChangePage}
                    rowsPerPage={5}
                    // onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[]}
                    //labelRowsPerPage=""
                    labelDisplayedRows={({ from, to, count }) => ``}
                    style={{overflow:'hidden'}}
                    classes={{
                        actions: classes.pagination,
                        toolbar: classes.paginationToolbar  
                    }}
                
                    />
                </div>
            </Grid>
        </Grid>
        );

    }

    handleChangePage = (event,value) => {
        //console.log("CHANGEING PAGE",value)
        this.setState({
            jamPage: value
        })
    }

    displayActivity = (classes, activityList) =>{
        let listArr = []
        //console.log(activityList)

        for(let index = 0; index < activityList.length; index++){
            let activity = activityList[index]
            if(index > 2){
                break;
            }
            else if(activity.__typename === "UserRecentActivityRecentTemplates"){
                break;
                // listArr.push(
                //     <Grid
                //         key={`${index + activity}`}
                //         container
                //         justify="center"
                //         alignItems="center"
                //         spacing={0}
                //         className={classes.jamBox}
                //         style={{height:"100px"}}
                //         onClick={()=>{
                //             this.setState({
                //                 dialogOpen: activity.status!=="interpreted" ? false : true,
                //                 selectedJB: {
                //                     jbData: activity,
                //                     type: "custom-personal"
                //                 }
                //             }, () =>{
                //                 if(activity.status!=="interpreted"){
                //                     this.handleDisplayInfoClick(this.state.selectedJB)
                //                 }
                //                 else{
                //                     this.jbIndex = index
                //                     this.jbID = this.state.selectedJB.jbData._id
                //                 }
                //             });
                //         }}
                //     >
                //         <Grid item xs={4} className={classes.jamBoxImg} style={{background:"#74BFC9"}}>
                //             <p className={classes.ownJamIcon}>
                //                 <TableChartOutlined  style={{fontSize:"3rem"}}/>
                //             </p>
                //         </Grid>
                //         <Grid item xs={8} className={classes.jamBoxFont} style={{fontSize:"12px",padding:"10px"}}>
                //             <Button style={{position:"absolute", top:"-15px", left:"5px", outline:"none", background:"white", color:"#828282", height:"20px", fontSize:"2px", }} disabled
                //                 startIcon={<TableChartOutlined style={{color:"#828282", fontSize:"14px"}}/>}>
                //                 <span style={{fontSize:"10px"}}>TEMPLATE</span>
                //             </Button>
                //             <span style={{fontWeight:"bold", fontSize:"16px"}}>
                //                 {activity.name}
                //             </span><br/>
                //             Created by <span style={{color:"#4173D6"}}>{activity.createdBy.name.first}</span><br/>
                //                                     <div style={{position:"absolute", bottom:"-15px", right:"5px"}}>
                //             {/*  ONCE PUBLISHED IS ESTABLISHED */}
                //             {/* <Button style={{color:"white",background:"#c4c4c4", marginRight:"2px"}} classes={{disabled: classes.ownJamLabel}} disabled startIcon={<VisibilityOffOutlined/>}>PRIVATE</Button>
                //             <Button style={{color:"white",background:"#c4c4c4", marginRight:"2px"}} classes={{disabled: classes.ownJamLabel}} disabled startIcon={<VisibilityOutlined/>}>PUBLIC</Button>
                //             <Button style={{color:"white", background:"orange"}}classes={{disabled: classes.ownJamLabel}} disabled> PUBLISHED</Button> */}
                //             {activity.status === "interpreted"
                //                 ?
                //                 activity.general.privacy === "Public" ?
                //                 <>
                //                     <Button style={{color:"white",background:"#c4c4c4", marginRight:"2px"}} classes={{disabled: classes.ownJamLabel}} disabled
                //                     startIcon={<VisibilityOutlined style={{fontSize:"14px"}}/>}>
                //                         <span style={{fontSize:"10px"}}>
                //                             PUBLIC
                //                         </span>
                //                     </Button>
                //                     <Button style={{color:"white", background:"orange"}}classes={{disabled: classes.ownJamLabel}} disabled>
                //                         <span style={{fontSize:"10px"}}>
                //                             PUBLISHED
                //                         </span>
                //                     </Button>
                //                 </>
                //                 :
                //                 <>
                //                     <Button style={{color:"white",background:"#c4c4c4", marginRight:"2px"}} classes={{disabled: classes.ownJamLabel}} disabled
                //                     startIcon={<VisibilityOffOutlined style={{fontSize:"14px"}}/>}>
                //                         <span style={{fontSize:"10px"}}>
                //                             PRIVATE
                //                         </span>
                //                     </Button>
                //                     <Button style={{color:"white", background:"orange"}}classes={{disabled: classes.ownJamLabel}} disabled>
                //                         <span style={{fontSize:"10px"}}>
                //                             PUBLISHED
                //                         </span>
                //                     </Button>
                //                 </>
                //                 :
                //                 <Button style={{color:"white", background:"#c4c4c4"}} disabled classes={{disabled: classes.ownJamLabel}} >
                //                      <span style={{fontSize:"10px"}}>
                //                         UNPUBLISHED
                //                     </span>
                //                 </Button>
                //             }
                //             </div>
                //         </Grid>
                //     </Grid>
                // )
            }
            else if(activity.__typename === "UserRecentActivityRecentJams"){
                listArr.push(
                    <Grid
                        key={`${index + activity}`}
                        container
                        justify="center"
                        alignItems="center"
                        spacing={0}
                        className={classes.jamBox}
                        style={{height:"100px"}}
                        onClick={() =>{
                            this.props.client.mutate({
                                mutation: USER_UPDATE_ACTIVITY,
                                variables:{
                                    _id: this.state.uid,
                                    _aid: activity._id,
                                    type: "jam",
                                    date: new Date()
                                }
                            }).then(() =>{
                                this.props.history.push({
                                    pathname: `/game/${activity._id}`
                                })
                            })
                        }}
                    >
                        {/* JAM IMAGE */}
                        <Grid item xs={4} className={classes.jamBoxImg} style={{background:"#faf7ea"}}>
                            <FPCards style={{color:"white", marginTop:"10px",fontSize:"50px"}}/>
                        </Grid>
                        {/* JAM INFO */}
                        <Grid item xs={8} className={classes.jamBoxFont} style={{fontSize:"12px", padding:"10px"}}>
                            <span style={{fontWeight:"bold", fontSize:"16px"}}>
                                {activity?.name}
                                {activity?.protected && <Lock style={{fontSize:"14px", marginTop:"-3px", marginLeft:"5px", color:"#C4C4C4"}}/>}
                            </span><br/>
                            Hosted by {activity?.createdBy?.name?.first} <br/>
                            <span style={{fontSize:"8px"}}>
                                <PeopleAlt className={classes.jamBoxIcon}/>
                            </span>
                            {activity?.participants?.length }
                        </Grid>
                    </Grid>
                )
            }
        }

        return listArr
    }

    linkSegment = (link) => {
        // console.log(link)
        let url = new URL(link)
        let segments = url.pathname.split('/')
        return segments[segments.length-1]
    }

    handleDisplayInfoClick = (selectedJB) =>{
        if(selectedJB.type === "custom-personal"){
            const {uid} = this.state

            this.props.client.mutate({
                mutation: USER_UPDATE_ACTIVITY,
                variables:{
                    _id: uid,
                    _aid: selectedJB.jbData._id,
                    type: "template",
                    date: new Date()
                }
            }).then(() =>{
                window.location.href=`/jambuilder/${selectedJB.jbData._id}`
            })
        }
        else{
            this.setState({
                dialogOpen: false,
            }, () =>{
                this.handleOpen("0")
            });
        }
    }

    createBranch = () => {
        
        let {name, selectedBranch, branchSuggest} = this.state

        let setup = {
            createdBy: getUserId(),
            name,
            password: this.passwordChecker(),
        }

        let automationChange = null
        if(branchSuggest){
            let link = this.linkSegment(selectedBranch.data.general.suggestedTemplate)
            let jb = this.state.publicJambuilders.find((pjb)=>{return pjb._id === link})

            automationChange = jb.general.gameLink
        }

        // console.log(automationChange)

        this.props.client.mutate({
            mutation: DUPLICATE_GAME,
            variables: {
                _id: selectedBranch._id,
                setup,
                automationChange,
            }
        }).then((status)=>{
            // console.log(status)
            this.setState({name:"",password:"", type: ""});
            this.jbIndex = null
            window.location.href=`/game/${status.data.gameDuplicate._id}`
            //window.location.reload(); // temporary for jambuilder setup
        })
    }

    createGame = () =>{
        let jamBuilder = null

        if(this.state.selectedJB.type === "custom-personal"){
            jamBuilder = this.state.jambuilders.find((jambuilder) => {
                if(jambuilder._id === this.jbID){
                    return jambuilder
                }
                else{
                    return false
                }
            })
        }
        else if(this.state.selectedJB.type === "custom-other"){
            jamBuilder = this.state.publicJambuilders[this.jbIndex]
        }
        
        if(this.state.selectedJB.brainstorm){
            jamBuilder = this.state.brainstormTemplate
        }

        if(this.state.selectedJB.firsttime){
            jamBuilder = this.state.firsttimeTemplate
        }

        const {name} = this.state
        const creator = getUserId();

        if(jamBuilder?.general && "gameLink" in jamBuilder.general){
            // duplicate jam
            // console.log("duplicate jam")
            let setup = {
                createdBy: creator,
                name,
                password: this.passwordChecker(),
            }
            // console.log(jamBuilder.general.gameLink)
            this.props.client.mutate({
                mutation: DUPLICATE_GAME,
                variables: {
                    _id: jamBuilder.general.gameLink,
                    setup,
                    automationChange: null,
                }
            }).then((status)=>{
                console.log(status)
                this.setState({name:"",password:"", type: ""});
                this.jbIndex = null
                window.location.href=`/game/${status.data.gameDuplicate._id}`
                //window.location.reload(); // temporary for jambuilder setup
            })
        }else{
            
            const general = jamBuilder?.general ?
                                jamBuilder.general :
                                {
                                    name: "Game Jam",
                                    deckEndpoint: "storyDesign",
                                    rulebook:"💬 Host writes criteria by attaching card to their posts \n\n ⏱ Timer can be set manually\n\n💡 Share your idea during your turn\n\n🏆 Host will choose the best idea",
                                    description:"",
                                    privacy:"Private",
                                    playerMode:"Quick",
                                    spectateMode:true,
                                }
            const data = {
                objects : [],
                latestObject : null,
                playerTurn: 0,
                turn: 1,
                phase: [],
                latestID: "0",
                general: general
            }

            console.log(this.state.selectedJB.firsttime)

            this.props.client.mutate({
                mutation: CREATE_GAME,
                variables:{
                    name: name,
                    createdBy: creator,
                    data: data,
                    automation: this.state.selectedJB.type === "custom-personal" || this.state.selectedJB.type === "custom-other" ?
                                    "JB:" + jamBuilder.configIndex + "/yamlConfig" :
                                    this.state.selectedJB.type,
                    password: this.passwordChecker(),
                    setup: false,
                    status: this.state.selectedJB.firsttime ? "started" : "ready"
                }
            }).then((status)=>{
                this.setState({name:"",password:"", type: ""});
                this.jbIndex = null
                window.location.href=`/game/${status.data.gameCreateOne._id}`
                //console.log(status)
            })
        }
    }

    createTemplate = () =>{
        const creator = getUserId();
        const username = getUsername();
        const {jambuilders, selectedJB, publicJambuilders, uid} = this.state

        let jamBuilderGraph = []
        let general = {}
        let jamBuilder = null

        if(selectedJB.type === "custom-personal"){
            jamBuilder = jambuilders.find((jb) => {
                if(jb._id === this.jbID){
                    return jb
                }else{
                    console.log(false)
                }
            })
            jamBuilderGraph = jamBuilder.graph
            general = jamBuilder.general

            // jamBuilderGraph = jambuilders.find((jambuilder) => {
            //     if(jambuilder._id === this.jbID){
            //         return jambuilder.graph
            //     }
            //     else{
            //         return false
            //     }
            // })
            // general = jambuilders.find((jambuilder) => {
            //     if(jambuilder._id === this.jbID){
            //         return jambuilder.general
            //     }
            //     else{
            //         return false
            //     }
            // })
        }
        else if(selectedJB.type === "custom-other"){
            jamBuilder = publicJambuilders[this.jbIndex]
            jamBuilderGraph = publicJambuilders[this.jbIndex].graph
            general = publicJambuilders[this.jbIndex].general
        }

        let deckEndpoint = this.state.selectedJB.type === "custom-personal" || this.state.selectedJB.type === "custom-other" ? 
                                {
                                    endpoint: this.state.selectedJB.jbData.deckEndpoint ,
                                    userDir: `${this.state.selectedJB.jbData.createdBy._id}-${replaceWhiteSpace(this.state.selectedJB.jbData.createdBy.name.first)}`,
                                }
                            : 
                                {
                                    endpoint: "storyDesign",
                                }
                                
        let deckAPI = deckEndpoint.endpoint === "storyDesign" ? `/api/game/getDeck` : `/api/game/getCustomDeck`;
        
        console.log(deckEndpoint)

        axios.get(`${config.backend.uri}${deckAPI}`,{params: deckEndpoint}).then((res)=>{
            let deck = res.data.deck

            const name = "Untitled Jam"
            const creator = getUserId();
            const gameGeneral = 
                                {
                                    name: "Game Jam",
                                    deckEndpoint: "storyDesign",
                                    rulebook:"💬 Host writes criteria by attaching card to their posts \n\n ⏱ Timer can be set manually\n\n💡 Share your idea during your turn\n\n🏆 Host will choose the best idea",
                                    description:"",
                                    privacy:"Private",
                                    playerMode:"Quick",
                                    spectateMode: true,
                                }
            const data = {
                objects : [],
                latestObject : null,
                playerTurn: 0,
                turn: 1,
                phase: [],
                latestID: "0",
                general: gameGeneral
            }
    
            this.props.client.mutate({
                mutation: CREATE_GAME,
                variables:{
                    name: name,
                    createdBy: creator,
                    data: data,
                    // automation: "story",
                    automation: this.state.selectedJB.type === "custom-personal" || this.state.selectedJB.type === "custom-other" ?
                                "JB:" + jamBuilder.configIndex + "/yamlConfig" : this.state.selectedJB.type,
                    setup: false,
                    build: true,
                }
            }).then((status)=>{
                let jbGeneral = gameGeneral
                jbGeneral.gameLink = status.data.gameCreateOne._id
                let gameID = status.data.gameCreateOne._id

                this.props.client.mutate({
                    mutation: CREATE_JAMBUILDER,
                    variables:{
                        name: this.state.name,
                        createdBy: creator,
                        configIndex: `${creator}-${replaceWhiteSpace(username)}-${jambuilders.length+1}`,
                        deckEndpoint:  this.state.selectedJB.type === "custom-personal" || this.state.selectedJB.type === "custom-other" ?
                                            this.state.selectedJB.jbData.deckEndpoint :
                                            "storyDesign",
                        templateType: this.state.selectedJB.type,
                        jamBuilderGraph: jamBuilderGraph,
                        general: jbGeneral,
                        deck: deck,
                    }
                }).then((status) =>{

                    // *** TEMPORARY FOR FREESTYLE & STORY
                    // Deep-clone the shared default game-data blob: gd/gd2 are module-level
                    // singletons, so mutating them (builderID/gameDeck below) would leak state
                    // into the next template creation.
                    let fgd = JSON.parse(JSON.stringify(this.state.selectedJB.type === "story" ? gd : gd2))

                    fgd.builderID = status.data.jamBuilderCreateOne._id

                    // Seed the reference game with the deck actually selected/stored on the
                    // JamBuilder record (transformed into the canvas shape, mirroring the server
                    // jambuilderSetup). Without this the canvas shows gd/gd2's hardcoded default
                    // deck until the user presses COMPILE. Clone `deck` since processDeckData
                    // mutates card objects.
                    try{
                        if(deck && deck.categories && deck.elements){
                            fgd.gameDeck = {
                                name: deck.title,
                                deck: processDeckData(JSON.parse(JSON.stringify(deck)))
                            }
                        }
                    }catch(seedErr){
                        console.log("createTemplate: deck seed failed, falling back to default gameDeck", seedErr)
                    }
                    // console.log(gameID)
                    this.props.client.mutate({
                        mutation: GAME_GD_UPDATE_BY_ID,
                        variables: {
                          _id : gameID,
                          gameData: fgd
                        }
                    })

                    this.props.client.mutate({
                        mutation: USER_UPDATE_ACTIVITY,
                        variables:{
                            _id: uid,
                            _aid: status.data.jamBuilderCreateOne._id,
                            type: "template",
                            date: new Date()
                        }
                    }).then(() =>{
                        this.props.history.push({
                            pathname: `/jambuilder/${status.data.jamBuilderCreateOne._id}`,
                            state: {type: this.state.selectedJB.type}
                        })
                        this.setState({name: "", selectedJB: {type: null, jbData: null}});
                    })
    
                })  
            })
        })

    }
}


export default withApollo(withRouter(withStyles(styles)(FrontPage)));
